'use client';
import React from 'react';
import {
  CrossedPrice,
  Heading,
  PlanCard,
  PlanFeatures,
  Price,
  PriceContainer,
  Text,
  Title
} from '../styled';
import { PriceSpinner } from '../PriceSpinner';
import { ToggleSwitch } from '@/components/payments/ToggleSwitch';
import { LK } from '@/consts';

export const StartPlan = () => {
  const [isPerMonth, setIsPerMonth] = React.useState(true);
  const [priceValue, setPriceValue] = React.useState<string[]>(['', ',', '', '9', '9']);

  return (
    <PlanCard>
      <Title>Start Plan</Title>
      <div>
        <Heading>Ideal for:</Heading>
        <Text>
          Freelancers, startups, and small businesses in UAE Free Zones with simple accounting needs
        </Text>
      </div>

      <div>
        <Heading>Features:</Heading>
        <PlanFeatures>
          <Text>Automated bank statement imports (daily, weekly, or monthly)</Text>
          <Text>
            VAT and corporate tax calculations (0% for QFZP, 9% for non-qualifying income &gt; AED
            375,000)
          </Text>
          <Text>Basic EmaarTax form preparation</Text>
          <Text>Automated reconciliation for transactions and invoices</Text>
          <Text>Invoice creation from photos, PDFs, Excel, WhatsApp, or existing systems</Text>
        </PlanFeatures>
      </div>
      <ToggleSwitch
        items={[
          { label: 'Monthly', value: 'monthly' },
          { label: 'Annual (Save 20%)', value: 'annual' }
        ]}
        value={isPerMonth ? 'monthly' : 'annual'}
        onChangeAction={(value) => {
          if (value === 'monthly') {
            setIsPerMonth(true);
            setPriceValue(['', ',', '', '9', '9']);
          } else {
            setIsPerMonth(false);
            setPriceValue(['', ',', '9', '9', '9']);
          }
        }}
      />
      <PriceContainer>
        <Price>
          <PriceSpinner value={priceValue} />
          <Title $fitContent>{isPerMonth ? '/month' : '/year'}</Title>
        </Price>

        <CrossedPrice>{isPerMonth ? 'AED 199/month' : 'AED 1,999/year'}</CrossedPrice>
      </PriceContainer>
      <a href={LK}>
        <button className="w-full transition hover:bg-gradient-white bg-gradient-custom hover:text-black text-white rounded-full text-center px-6 py-3 text-nowrap">
          Start now
        </button>
      </a>
    </PlanCard>
  );
};
